import { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Space, Typography, Form } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { AddUserModal, EditUsersModal } from "components";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import "./style.scss";

export const ManageUsers: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [userStatus, setUserStatus] = useState<boolean>(false);
	const [userRoles, setUserRoles] = useState<CheckboxValueType[]>([]);
	// const [userData, setUserData] = useState<DataType[]>([]);
	const [birthdate, setBirthDate] = useState<string>("");
	const [users, setUsers] = useState<any[]>();
	const [currentUserInfo, setCurrentUserInfo] = useState<any[]>([]);
	// const [usersInfoToEdit, setUsersInfoToEdit] = useState<any[]>([]);
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	// const handleDelete = (item: DataType) =>
	// 	setUserData((prevState) => prevState.filter((data) => data !== item));

	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true)
		if (id) {
			const {
				data: {
					data: { user },
				},
			} = await api.get(`/manager/users/${id}`);
			setIsLoading(false)
			setCurrentUserInfo(user);
		}
	};
	const menu = (
		<Menu
			selectable
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	// useEffect(() => {
	// 	setUserData([
	// 		{
	// 			key: "1",
	// 			name: "John Brown",
	// 			email: "john.brown@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 		{
	// 			key: "2",
	// 			name: "Jim Green",
	// 			email: "jim.green@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 		{
	// 			key: "3",
	// 			name: "Joe Black",
	// 			email: "joe.black@gmail.com",
	// 			group: "Aluno",
	// 			lastaccess: "20/01/2000",
	// 			status: "Ativo",
	// 			created_at: "20/04/2001",
	// 		},
	// 	]);
	// }, []);

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "name",
			key: "name",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{record?.person?.name}</p>
			),
		},
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
		{
			title: "Data de nascimento",
			dataIndex: "birth_date",
			key: "birth_date",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{record?.person?.birth_date}</p>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Grupo",
			dataIndex: "group",
			key: "group",
			render: (t_, record) => (
				<p style={{ margin: 0 }}>
					{record?.roles?.map((item: any) => item?.name).join(", ")}
				</p>
			),
		},

		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setUsers(undefined);
		api
			.get(
				`/manager/users?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setUsers(res?.data?.data?.users);
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});
	}, [selectedValue, paginationInfo]);

	return (
		<div className="users">
			<AddUserModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				setUsers={setUsers}
			/>
			<EditUsersModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				setUsers={setUsers}
				currentUserInfo={currentUserInfo}
			/>

			<div className="users__container">
				<h1 className="users__container__title">Usuários</h1>
				<div className="users__container__input">
					<div className="users__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						usuários
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="users__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Usuário
					</button>
				</div>
				<Table
					loading={users === undefined || isLoading}
					columns={columns}
					dataSource={users}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
